import { useTheme } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'

/**
 * @typedef {'small' | 'medium' | 'large'} MUIButtonSize
 * @typedef {'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'inherit' | 'default'} MUIColor
 */
/**
/**
 * MARKDOWN styled code button
 *
 * @param {Object} props
 * @param {(React.ReactNode|Element|String )} props.children - Content of the code button
 * @param {MUIButtonSize} [props.size] - Size of the button
 */

const CodeButton = ( { children, size = "normal" } ) => {

    const { theme } = useTheme()

    return (
        <code className={`code-button ${size || ""} ${theme}`}>{children}</code>
    )
}

CodeButton.protoType = {
    size: PropTypes.oneOf( ["small", "normal", "large"] )
}

export default CodeButton
